import { message, notification } from 'ant-design-vue'
import { TimeOut } from '~/services/apis/timeout'

export const useNotification = () => {
	const notificationState = useState<NotificationContext | null>('Notification')
	const clear = () => {
		notificationState.value = null
	}
	const alert = (arg: { status: number; message: string }) => {
		TimeOut(100).then(() => {
			notificationState.value = {
				notificationStatus: arg.status,
				notificationMessage: arg.message
			}
			if (notificationState.value) {
				if (Number(notificationState.value.notificationStatus) > 300) {
					notification.open({
						message: 'Oops ):',
						description: notificationState.value?.notificationMessage,
						placement: 'top',
						class: 'notification-custom-danger'
					})
				} else if (Number(notificationState.value.notificationStatus) === 300) {
					message.warn({
						content: `${notificationState.value.notificationMessage}`,
						class: 'notify',
						key: 'notification-warning'
					})
				} else {
					message.success({
						content: `${notificationState.value.notificationMessage}`,
						class: 'notify',
						key: 'notification-success'
					})
				}
			}
		})
	}
	return {
		clear,
		alert
	}
}
